module.exports = __webpack_public_path__ + "img/workable.ab99cccf.png";